import React from "react";
// import { Link } from "react-scroll";
import { Link, useLocation } from "react-router-dom";

const NavBar = ({ links }) => {
  const location = useLocation();
  return (
    <nav>
      <ul className="flex gap-10">
        {links.map((link) => {
          const isActive = location.pathname === link.href; // Check if the current URL matches
          return (
            <li key={link.href}>
              <Link
                to={link.href}
                smooth
                className="hover:text-link-hovered text-link-unhover transition-colors font-medium text-[16px] leading-[140%] tracking-[0] relative group cursor-pointer"
              >
                {link.text}
                {/* Underline Animation */}

                <span
                  className={`absolute left-0 bottom-[-4px] w-full h-[2px] bg-white origin-left 
                             scale-x-0 transition-transform duration-300 ease-in-out group-hover:scale-x-100 ${
                               isActive
                                 ? "scale-x-100"
                                 : "scale-x-0 group-hover:scale-x-100"
                             }`}
                ></span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default NavBar;
